import { DefaultDomain } from '../songwhipApi/types';

export const DEFAULT_DOMAIN: DefaultDomain = 'sng.to';
export const DEFAULT_DOMAIN_ORCHARD: DefaultDomain = 'orch.stream';

export const DEFAULT_DOMAINS: DefaultDomain[] = [
  DEFAULT_DOMAIN,
  DEFAULT_DOMAIN_ORCHARD,
];
